import { Method, AxiosRequestHeaders, AxiosError } from "axios";
import { getAccessToken, logout } from "./Auth";
import clientTokenHelper from "./ClientTokenHelper";
import { BaseHttpService, ErrorResponseData } from "./BaseHttpService";

const RETRY_LIMIT = 3;

const UNAUTHORIZED_CODE = 401;

// Need a new temporary token on this response.
const UNAUTHORIZED_ERRORS = [
  "BadTokenFormat",
  "BadTokenKey",
  "InvalidTokenSignature",
  "TokenDecodeError",
  "TokenExpired",
  "WrongSender",
];

export default abstract class AuthHttpService extends BaseHttpService {

  protected constructor (readonly url?: string) {
    super(url);
  }

  protected async request(method: Method, url: string, data?: any, headers?: AxiosRequestHeaders, retry?: number): Promise<any> {
    const userToken: string | null = await getAccessToken();
    const clientToken: string | null = userToken === null ? await clientTokenHelper.get() : null;
    const token = userToken || clientToken;

    const requestHeaders: AxiosRequestHeaders = headers || {};

    if (token !== null) {
      requestHeaders["Authorization"] = `Bearer ${token}`;
    }

    return super.request(method, url, data, requestHeaders)
      .catch((reason: AxiosError<ErrorResponseData | undefined>) => {
        const requestRetry = retry || 1;
        const { response } = reason;

        const code = response?.data?.error?.code;
        const status = response?.status;

        if (userToken !== null && status === UNAUTHORIZED_CODE) {
          logout();
        }

        if (
          clientToken !== null
          && requestRetry < RETRY_LIMIT
          && status === UNAUTHORIZED_CODE
          && UNAUTHORIZED_ERRORS.indexOf(code || "") >= 0
        ) {
          console.debug(`Request failed with code=${code}, getting new guest token, retry=${retry}`);

          clientTokenHelper.reset();
          return this.request(method, url, data, headers, requestRetry + 1);
        } else {
          console.debug(`Request failed with code=${code}, not getting new guest token, retry=${retry}.`);
        }

        return Promise.reject(reason);
      });
  }
}
